import { fetchRelatedProducts } from 'api/interna-api';
import Heading from "components/atoms/Heading";
import Image from "components/atoms/Image";
import Loading from "components/atoms/Loading";
import Text from "components/atoms/Text";
import Layout from "components/layout";
import Breadcrumb, {
  BreadcrumbItem,
  BreadcrumbItemLink,
} from "components/molecules/Breadcrumb";
import Carousel from 'components/molecules/Carousel';
import CarouselItem from 'components/molecules/Carousel/CarouselItem';
import Product from 'components/molecules/Product';
import Grid, { GridCol, GridRow } from "components/organisms/Grid";
import Section from "components/organisms/Section";
import { BASE_URL } from "constants/env";
import { CAROUSEL_IDS, PRODUCT_DETAIL } from 'constants/swiper';
import React, { lazy, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { requestFetchNewsDetail } from "redux/actions/news/list";
import { SwiperSlide } from 'swiper/react';
import { joinClassnames } from 'utils/map-modifier';
import "./index.scss";
const Head = lazy(() => import("components/molecules/Head"));
interface TipDetailProps {
  match: any;
}

const TipDetail: React.FC<TipDetailProps> = (props: TipDetailProps) => {
  const owlClass = "p-tipdetail";
  const history = useHistory();
  const dispatch = useDispatch();
  const newsData = useSelector((state: any) => state.news);
  const {
    data: { newsDetail, news: relatedNews },
  } = newsData;
  const {
    match: {
      params: { slug },
    },
  } = props;

  useEffect(() => {
    if (slug) {
      dispatch(requestFetchNewsDetail(slug));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, slug]);

  const [metaData, setMetaData] = useState<HeadData>();
  const [productRelated, setProductRelated] = useState([]);

  useEffect(() => {
    const getProductRelated = async (productIdsFinal: Array<number>) => {
      const dataProductsData = await fetchRelatedProducts({ ids: productIdsFinal.join(',') });
      setProductRelated(dataProductsData?.products || []);
    }
    if (newsDetail && newsDetail.productIdRelated && newsDetail.productIdRelated.length > 0) {
      const { productIdRelated } = newsDetail;
      getProductRelated(productIdRelated);
    }
  }, [newsDetail]);

  useEffect(() => {
    if (slug && newsData && newsData.data && newsData.data.newsDetail) {
      const { seo } = newsData.data.newsDetail;

      if (seo && seo.metaDataTranslations) {
        const { metaDataTranslations } = seo;
        const {
          description,
          extraData,
          keywords,
          title,
        } = metaDataTranslations[0];

        setMetaData({
          titlePage: title,
          title,
          description,
          keywords,
          image: typeof extraData === "string" && JSON.parse(extraData).image,
        });
      }

      const {
        title,
        thumbnail,
        created_at,
        updated_at,
        description,
      } = newsData.data.newsDetail;

      const structuredItem: ArticleStructured = {
        "@context": "http://schema.org",
        "@type": "Article",
        headline: title,
        image: [`${BASE_URL}${thumbnail}`],
        author: {
          "@type": "Thing",
          name: "Daikin Vietnam",
          url: window.location.href,
        },
        editor: { name: "Đội biên tập viên Daikin E-Shop" },
        genre: "https://shop.daikin.com.vn/kinh-nghiem-hay",
        keywords: (metaData && metaData.keywords) || "",
        datePublished: created_at,
        dateModified: updated_at,
        description,
      };

      setMetaData(prevData =>
        prevData
          ? {
            ...prevData,
            article: structuredItem,
          }
          : {
            titlePage: title,
            title,
            description,
            keywords: "",
            image: "",
            article: structuredItem,
          },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsData, slug]);

  const onGotoNews = (slug: string) => {
    history.push(`/kinh-nghiem-hay/${encodeURIComponent(slug)}`);
  };

  return (
    <div className={owlClass}>
      <Layout>
        <Head data={metaData} />
        {!newsData.loading ? (
          <React.Fragment>
            <Breadcrumb>
              <BreadcrumbItemLink href="/">Trang chủ</BreadcrumbItemLink>
              <BreadcrumbItemLink href="/kinh-nghiem-hay">
                Kinh Nghiệm Hay
              </BreadcrumbItemLink>
              <BreadcrumbItem> {newsDetail.title} </BreadcrumbItem>
            </Breadcrumb>
            <Section space="space-xs">
              <Grid>
                <GridRow>
                  <GridCol no_gutters={true} colLg={8}>
                    <div className={`${owlClass}-category`}>
                      <Text modifiers={["primary"]} size="sm">
                        {newsDetail.category_name}
                      </Text>
                    </div>
                    <Heading
                      type="h1"
                      size="medium"
                      weight="medium"
                      styles={{ lineHeight: 1.45 }}
                      modifiers={["normal"]}
                    >
                      {newsDetail.title}
                    </Heading>
                    <div className={`${owlClass}-maincontent`}>
                      <div
                        dangerouslySetInnerHTML={{ __html: newsDetail.content }}
                      ></div>
                    </div>
                  </GridCol>
                  <GridCol no_gutters={true} colLg={4}>
                    <div className={`${owlClass}-rightcontent`}>
                      <Text weight="bold">Bài viết gần đây</Text>
                      {relatedNews.length > 0 &&
                        relatedNews.map((news: any, i: number) => (
                          <div
                            className={`${owlClass}-rightcontent-element`}
                            key={i}
                            onClick={() => onGotoNews(news.slug)}
                          >
                            <GridRow>
                              <GridCol colLg={6}>
                                <Image
                                  src={`${BASE_URL}/${news.thumbnail}`}
                                  alt={news.title}
                                />
                              </GridCol>
                              <GridCol colLg={6}>
                                <div
                                  className={`${owlClass}-rightcontent-element-category`}
                                >
                                  <Text modifiers={["primary"]} size="sm">
                                    {newsDetail.category_name}
                                  </Text>
                                </div>
                                <div
                                  className={`${owlClass}-rightcontent-element_text`}
                                >
                                  <Text>{news.title}</Text>
                                </div>
                              </GridCol>
                            </GridRow>
                          </div>
                        ))}
                    </div>
                  </GridCol>
                </GridRow>
              </Grid>
            </Section>
            {
              newsDetail.productIdRelated && newsDetail.productIdRelated.length > 0 && (
                <div id="relatedProduct">
                  <Section
                    space="space-xs-b"
                    className="section-pt"
                  >
                    <Grid>
                      <GridRow>
                        <GridCol>
                          <Carousel
                            pagination
                            title={"Sản phẩm liên quan"}
                            breakpoints={PRODUCT_DETAIL(4)}
                            id={`product-detail-${CAROUSEL_IDS.DETAIL_RELATED_PRODUCTS}`}
                            className={joinClassnames(
                              `${newsDetail.productIdRelated?.length <= 4 &&
                              "item-less-than-4"}`,
                            )}
                          >
                            {productRelated.map(
                              p => (
                                <SwiperSlide key={p.id}>
                                  <CarouselItem>
                                    <Product
                                      product={p}
                                      addToCardButton={true}
                                      // onCompare={(e: any) => onCompare(e, p.id, p.productTypeId, p.parentTypeId)}
                                      className="no-animate-item"
                                      tags={
                                        p.tags && p.tags.length > 0
                                          ? p.tags.map((tag, index) => (
                                            <div
                                              key={index}
                                              className="m-product_trademark_item service"
                                            >
                                              <Text
                                                modifiers={["primary"]}
                                                size="sm"
                                              >
                                                {tag.name}
                                              </Text>
                                            </div>
                                          ))
                                          : []
                                      }
                                      trademarks={
                                        p.trademarks.length > 0
                                          ? p.trademarks.map(tra => tra.name)
                                          : []
                                      }
                                      hasCashbackLabel={productRelated.some(
                                        item => item.cashback_text !== null || item.cashback_img !== null,
                                      )}
                                      list="relatived-products"
                                    />
                                  </CarouselItem>
                                </SwiperSlide>
                              ),
                            )}
                          </Carousel>
                        </GridCol>
                      </GridRow>
                    </Grid>
                  </Section>
                </div>
              )
            }
          </React.Fragment>
        ) : (
          <Loading />
        )}
      </Layout>
    </div>
  );
};

TipDetail.defaultProps = {};

export default TipDetail;
